import { render, staticRenderFns } from "./ContactPersonInfo.vue?vue&type=template&id=d24a6cce&"
import script from "./ContactPersonInfo.vue?vue&type=script&lang=js&"
export * from "./ContactPersonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports